import { PAGE_SIZE_OPTIONS } from '@/constants/node';
import { setPageSize } from '@/stores/dataManagementStore';
import { cn } from '@/utils/classname';
import * as Select from '@radix-ui/react-select';

export const PageSizeSelector = ({
  pageSize,
  isFetching,
}: {
  pageSize: number;
  isFetching: boolean;
}) => {
  return (
    <div className="flex items-center justify-self-end gap-3">
      <span className="color-neutral-600 typo-text-s">Items per page</span>
      <Select.Root
        disabled={isFetching}
        value={pageSize.toString()}
        onValueChange={value => setPageSize(parseInt(value))}
      >
        <Select.Trigger asChild>
          <div
            className={cn(
              'group min-w-20 flex items-center rounded-1 bg-transparent color-neutral-600 typo-text-s px-3 py-2 justify-between transition-colors',
              'b-1 b-solid b-transparent hover:b-neutral-400 cursor-pointer',
              'data-[disabled]:opacity-50 data-[disabled]:hover:b-transparent data-[disabled]:cursor-not-allowed',
              'data-[state=open]:b-neutral-400 data-[state=open]:bg-neutral-200',
            )}
            role="button"
          >
            <Select.Value>{pageSize}</Select.Value>
            <Select.Icon className="i-skand-dropdown rotate-180 text-3 transition-transform group-[[data-state=open]]:rotate-0" />
          </div>
        </Select.Trigger>

        <Select.Portal>
          <Select.Content
            className={cn(
              'bg-neutral-100',
              'border-1',
              'border-neutral-400',
              'border-solid',
              'overflow-auto',
              'p-1',
              'rounded-1',
              'z-1',
              'w-[var(--radix-select-trigger-width)]',
            )}
            position="popper"
          >
            <Select.Viewport>
              {PAGE_SIZE_OPTIONS.map(size => {
                return (
                  <Select.Item
                    className={cn(
                      'color-neutral-600',
                      'cursor-pointer',
                      'flex-nowrap',
                      'flex',
                      'items-center',
                      'justify-between',
                      'px-2',
                      'py-2px',
                      'rounded-2px',
                      'typo-text-s',
                      'outline-none',
                      'hover:bg-neutral-200 hover:color-neutral-800 hover:typo-text-s-em',
                    )}
                    key={size}
                    value={size.toString()}
                  >
                    <Select.ItemText>{size}</Select.ItemText>
                    <Select.ItemIndicator>
                      <div className="i-skand-done" />
                    </Select.ItemIndicator>
                  </Select.Item>
                );
              })}
            </Select.Viewport>
          </Select.Content>
        </Select.Portal>
      </Select.Root>
    </div>
  );
};
